export const chartGenerationPrompt = (chartType, message) => {
  return JSON.stringify({
    messages: [
      {
        role: "system",
        content:
          "You are a PPTGen.js expert that helps generate chart syntax with sample data. You understand PPTGen.js chart API and provide working code examples.",
      },
      {
        role: "user",
        content: `Please provide PPTGen.js syntax to create a chart slide with the following requirements:
          - name the chart data variable as var "chartData"
          - Create a ${chartType} chart showing monthly sales data
          - Data on which chart needs to be generate is ${message}`,
      },
    ],
    temperature: 0.7,
    max_tokens: 800,
  });
};


export const tableGenerationPrompt = (message) => {
  return JSON.stringify({
    messages: [
      {
        role: "system",
        content:
          "You are a PPTGen.js expert that helps generate table syntax with sample data. You understand PPTGen.js table API and provide working code examples.",
      },
      {
        role: "user",
        content: `Please provide PPTGen.js syntax to create a table slide with the following requirements:
          - name the table data variable as "tableData"
          - tableData should be an array and all arrays inside that
          - Create a table showing these data
          - keep maximum length of array is 5 (five)
          - Do not exceed Array and table data should be proper like this with proper header [
              { text: "Header 1", options: { bold: true } },
              { text: "Header 2", options: { bold: true } },
            ],
            ["Row 1 Col 1", "Row 1 Col 2"],
            ["Row 2 Col 1", "Row 2 Col 2"]
          - data is ${message}`,
      },
    ],
    temperature: 0.7,
    max_tokens: 800,
  });
};




export const textGenerationPrompt = (paragraph) => {
  return JSON.stringify({
    messages: [
      {
        role: "system",
        content:
          "You are an expert at converting paragraphs into structured bullet points. You understand how to break down text into meaningful, concise points.",
      },
      {
        role: "user",
        content: `Please convert the following paragraph into bullet points. Each bullet point should be formatted as an object like this:
              [{
                text: "The importance of teamwork in achieving goals.",
                options: {}
          }]
              Generate meaningful bullet points from this paragraph and return them as a single array containing sub-arrays, where each sub-array has maximum 7 minimum 3 bullet point objects.
              Requirements:
              - Keep min 3 array but maximum seven
              - Add "\\n" at the end of each bullet point in text key
              - Total word count across all bullet points should not exceed 75
              - Vary the length of text in different arrays
              - Do not add any other text or comment in the response
              -Provide Only JSON response
              Paragraph to convert: ${paragraph}`,
      },
    ],
    temperature: 0.7,
    max_tokens: 800,
  });
};


export const summarizeTextPrompt = (paragraph, TEXT_LIMIT) => {
  return JSON.stringify({
    messages: [
      {
        role: "system",
        content: `You are an AI that summarizes text by shortening it while not necessarily preserving the full context or meaning.
          - Your goal is to create a **shortened version** of the provided paragraph.
          - The summary should be **concise, readable, and within the provided text limit**.
          - Avoid excessive detail but retain the core idea where possible.`,
      },
      {
        role: "user",
        content: `Please summarize the following paragraph while keeping it **within the given text limit**.
          - The summary should be in **paragraph form**, not bullet points.
          - Ensure it is **coherent and well-structured** while being significantly shorter than the original.
          - Keep words limit: ${TEXT_LIMIT}
          - Paragraph to summarize: ${paragraph}`,
      },
    ],
    temperature: 0.7,
    max_tokens: 800,
  });
};



export const getTextDataFromSummaryPrompt = (paragraph) => {
  return JSON.stringify({
    messages: [
      {
        role: "system",
        content:
          "You are an expert at converting paragraphs into structured bullet points. You understand how to break down text into meaningful, concise points.",
      },
      {
        role: "user",
        content: `Please convert the following paragraph into bullet points. Each bullet point should be formatted as an object like this:
              [{
                text: "The importance of teamwork in achieving goals.",
                options: {}
          }]
              Generate meaningful bullet points from this paragraph and return them as a single array.
              Requirements:
              - Give me one array with full of objects 
              - Add "\\n" at the end of each bullet point in text key
              - Total word count across all bullet points should not exceed 75
              - Vary the length of text in different arrays
              - Do not add any other text or comment in the response
              - Provide Only JSON response
              Paragraph to convert: ${paragraph}`,
      },
    ],
    temperature: 0.7,
    max_tokens: 800,
  });
};
